// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetNewbuildingsForBuildersPromoSliderRequest,
  TGetNewbuildingsForBuildersPromoSliderModel,
  IMappers,
  TGetNewbuildingsForBuildersPromoSliderResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingsForBuildersPromoResponse } from '../../entities/get_newbuildings_for_builders_promo_slider/GetNewbuildingsForBuildersPromoResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingsForBuildersPromoSliderModel(
  parameters: IGetNewbuildingsForBuildersPromoSliderRequest,
): TGetNewbuildingsForBuildersPromoSliderModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-search',
    pathApi: '/v1/get-newbuildings-for-builders-promo-slider/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetNewbuildingsForBuildersPromoSliderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetNewbuildingsForBuildersPromoSliderRequest;
}

export async function fetchGetNewbuildingsForBuildersPromoSlider<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingsForBuildersPromoSliderOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingsForBuildersPromoSliderResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingsForBuildersPromoSliderModel(parameters),
    config,
  )) as FetchResponse<TGetNewbuildingsForBuildersPromoSliderResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsForBuildersPromoResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingsForBuildersPromoSliderResponse>;
}
